// TODO: move this whole util file into /PanelBank
import {useSyncExternalStore} from 'react';

export interface CurrentPageBySectionRefID {
  [sectionRefID: string]: number;
}

// The browser fires `change` only when the window crosses the breakpoint, so
// subscribers do no work on resizes that stay on one side of it.
const MOBILE_MEDIA = window.matchMedia('(max-width: 768px)');

export function isMobile(): boolean {
  return MOBILE_MEDIA.matches;
}

const subscribeToMobileMedia = (onChange: () => void) => {
  MOBILE_MEDIA.addEventListener('change', onChange);
  return () => MOBILE_MEDIA.removeEventListener('change', onChange);
};

/**
 * `isMobile()` for use during render. The React Compiler caches values it
 * cannot see change, so a render-time `isMobile()` call would keep its first
 * answer after a resize. This hook re-renders the caller when the window
 * crosses the breakpoint. Event handlers can keep calling `isMobile()`.
 */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribeToMobileMedia, isMobile);
}
